export default "__VITE_ASSET__BfVl8LXb__"